import { Membership } from "../../../business-objects/membership/membership.model";
import { User } from "../../../business-objects/user/user.model";

export interface IAclCategoryModalItemModelArgs {
    activeMembership: Membership;
    category: string;
    categoryId: string;
    enabled: boolean;
    membership: Membership;
    user: User;
}

export class AclCategoryModalItemModel {
    protected _activeMembership: Membership;
    protected _category: string;
    protected _categoryId: string;
    protected _enabled: boolean;
    protected _membership: Membership;
    protected _user: User;

    constructor(args: IAclCategoryModalItemModelArgs) {
        Object.keys(args).forEach(key => {
            this[`_${key}`] = args[key];
        });
    }

    get accessGroupIds(): Array<string> {
        return this.membership.accessGroups;
    }

    get grantedCategoryIds(): Array<string> {
        return this._membership[this._category] || [];
    }

    get label(): string {
        return this._user ? `${this._user.name} ${this._user.email}` : "";
    }

    get isActiveUser(): boolean {
        return this._membership.id === this._activeMembership.id;
    }

    get membership(): Membership {
        return this._membership;
    }

    /**
     * Returns an instance of membership which can be submitted to the store.
     * This method will add or remove, depending on `value`, the `categoryId` from the membership.
     */
    get submitData(): Membership {

        if (this.value) {
            return new Membership({
                ...this._membership,
                [this._category]: [...this.grantedCategoryIds, this._categoryId]
            });
        } else {
            return new Membership({
                ...this._membership,
                [this._category]: this.grantedCategoryIds.filter(id => id !== this._categoryId)
            });
        }
    }

    get value(): boolean {
        return this._activeMembership.id === this._membership.id || this._enabled;
    }

    grant(): AclCategoryModalItemModel {
        return new AclCategoryModalItemModel({
            activeMembership: this._activeMembership,
            category: this._category,
            categoryId: this._categoryId,
            enabled: true,
            membership: this._membership,
            user: this._user
        });
    }

    revoke(): AclCategoryModalItemModel {

        // you can't revoke a category from your self
        if (this.isActiveUser) {
            return this;
        }

        return new AclCategoryModalItemModel({
            activeMembership: this._activeMembership,
            category: this._category,
            categoryId: this._categoryId,
            enabled: false,
            membership: this._membership,
            user: this._user
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/form/acl-category-modal-item.model.ts